import { render, staticRenderFns } from "./ViewFormMassDelivery.vue?vue&type=template&id=58156f7b&scoped=true&"
import script from "./ViewFormMassDelivery.vue?vue&type=script&lang=js&"
export * from "./ViewFormMassDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ViewFormMassDelivery.vue?vue&type=style&index=0&id=58156f7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58156f7b",
  null
  
)

export default component.exports